import React, { useContext, useEffect, useRef } from "react";
import { Animated, ScrollView, View, TouchableOpacity, Image, Text, StyleSheet } from "react-native";
import { RootContext } from "../../App";
import { THEME_COLORS } from "../../common/themes";
import { getAvailableScreens } from "../../component/Login/Auth";
import { AntDesign } from "@expo/vector-icons";
import { PurchaserContext, PurchaserInterface } from "@src/context/PurchaserContext";

const HeaderTab = (props) => {
  const { onPress, isActive, text, bottomText, img, hasSubHeader } = props;
  const IconComponent = props.icon;

  console.log("HAS SUB HEADER", hasSubHeader, props?.sparesTabs);

  return (
    <View>
      <TouchableOpacity
        style={[headerStyles.tab, { backgroundColor: isActive ? THEME_COLORS.sideMenuBgV3 : "#F7F2FA" }]}
        onPress={onPress}
      >
        {IconComponent && (
          <IconComponent
            style={{
              marginLeft: 10,
              color: isActive ? THEME_COLORS.purple : THEME_COLORS.sideMenuGrey,
            }}
          />
        )}
        {img && (
          <Image
            source={img}
            style={{
              width: 22,
              height: 22,
              tintColor: isActive ? THEME_COLORS.purple : THEME_COLORS.sideMenuGrey,
            }}
            resizeMode="contain"
          />
        )}
        <Text
          style={{
            marginStart: 20,
            fontFamily: "NotoSans",
            fontSize: 12,
            color: isActive ? THEME_COLORS.purple : THEME_COLORS.sideMenuGrey,
          }}
        >
          {bottomText ?? text}
        </Text>
      </TouchableOpacity>
      {text === "Spares"
        ? props?.sparesTabs
            ?.filter?.((val) => val?.parent === "Spares")
            ?.map((val) => {
              let isSelected = false;
              if (props?.navigation?.state?.routeName === val?.screen) {
                if (val?.screen === "SparePartsScreen") {
                  if (props?.navigation?.state?.params?.tab === val?.tab) {
                    isSelected = true;
                  }
                } else if (val?.screen === "Purchase") {
                  isSelected = true;
                } else if (val?.screen === "InventoryReplenishment") {
                  isSelected = true;
                } else if (val?.screen === "ReceivePartsVendor") isSelected = true;
                else if (val?.screen === "ReceivePartsTO") isSelected = true;
                else if (val?.screen === "RaiseRequest") isSelected = true;
                else if (val?.screen === "ByCarV2") isSelected = true;
                else if(val?.screen === 'SparesJobCard') isSelected = true;
              }

              return (
                <>
                  {hasSubHeader[val?.tab] === undefined || val?.subHeader ? (
                    <TouchableOpacity
                      style={[
                        headerStyles.tabCon,
                        {
                          flexDirection: "row",
                          backgroundColor: isSelected ? "#3030300D" : "",
                          alignItems: "center",
                          justifyContent: "space-between",
                        },
                      ]}
                      disabled={isSelected}
                      onPress={() => {
                        props?.tabOnPress(val?.screen, val?.tab);
                      }}
                    >
                      <Text style={headerStyles.tabText}>{val?.label}</Text>
                      {val?.subHeader && props?.sparesTabs?.filter?.((v) => val?.tab === v?.tab)?.length > 2 ? (
                        <AntDesign name={hasSubHeader[val?.tab] ? "caret-up" : "caret-down"} size={10} color="#7D7D7D" />
                      ) : null}
                    </TouchableOpacity>
                  ) : hasSubHeader[val?.tab] ? (
                    <TouchableOpacity
                      style={[
                        headerStyles.tabCon,
                        {
                          backgroundColor: isSelected ? "#3030300D" : "",
                        },
                      ]}
                      disabled={isSelected}
                      onPress={() => {
                        props?.tabOnPress(val?.screen, val?.tab);
                      }}
                    >
                      <Text style={[headerStyles.tabText, { marginStart: 60 }]}>{val?.label}</Text>
                    </TouchableOpacity>
                  ) : null}
                </>
              );
            })
        : text === "Catalogue"
          ? props?.sparesTabs
              ?.filter?.((val) => val?.parent === "Catalogue")
              ?.map?.((val) => {
                let isSelected = false;

                if (props?.navigation?.state?.routeName === val?.screen) {
                  if (val?.screen === "CatalogueRequests") {
                    isSelected = true;
                  } else if (val?.screen === "SparePartsScreen") {
                    if (props?.navigation?.state?.params?.tab === val?.tab) {
                      isSelected = true;
                    }
                  } else if (val?.screen === "CatalogueManagementV2") {
                    isSelected = true;
                  }
                }

                return (
                  <>
                    {val?.hide ? null : hasSubHeader[val?.tab] === undefined || val?.subHeader ? (
                      <TouchableOpacity
                        style={[
                          headerStyles.tabCon,
                          {
                            flexDirection: "row",
                            backgroundColor: isSelected ? "#3030300D" : "",
                            alignItems: "center",
                            justifyContent: "space-between",
                          },
                        ]}
                        disabled={isSelected}
                        onPress={() => {
                          props?.tabOnPress(val?.screen, val?.tab);
                        }}
                      >
                        <Text style={headerStyles.tabText}>{val?.label}</Text>
                        {val?.subHeader && props?.sparesTabs?.filter?.((v) => val?.tab === v?.tab)?.length > 2 ? (
                          <AntDesign
                            name={hasSubHeader[val?.tab] ? "caret-up" : "caret-down"}
                            size={10}
                            color="#7D7D7D"
                          />
                        ) : null}
                      </TouchableOpacity>
                    ) : hasSubHeader[val?.tab] ? (
                      <TouchableOpacity
                        style={[
                          headerStyles.tabCon,
                          {
                            backgroundColor: isSelected ? "#3030300D" : "",
                          },
                        ]}
                        disabled={isSelected}
                        onPress={() => {
                          props?.tabOnPress(val?.screen, val?.tab);
                        }}
                      >
                        <Text style={[headerStyles.tabText, { marginStart: 60 }]}>{val?.label}</Text>
                      </TouchableOpacity>
                    ) : null}
                  </>
                );
              })
          : null}
    </View>
  );
};

const Sidebar = ({ navigation, userMetaData, nonSidemenuScreens, sparesTabs, onMouseLeave }): JSX.Element => {
  const { setMiscModal } = useContext<PurchaserInterface>(PurchaserContext);

  const animationWidth = useRef<Animated.Value>(new Animated.Value(72)).current;

  const screens = !!userMetaData
    ? getAvailableScreens(userMetaData).filter((val) => !nonSidemenuScreens.includes(val.screen))
    : [];
  const navState = navigation.state;

  const sparesExtraScreens = [
    "Purchase",
    "InventoryReplenishment",
    "InvenRepPurchaseRequest",
    "ReceivePartsVendor",
    "ReceivePartsTO",
    "ByCarV2",
    "RaiseRequest",
    "CatalogueManagementV2",
  ];
  const { hasSubHeader, updateHasSubHeader } = React.useContext(RootContext);

  useEffect(() => {
    setMiscModal(false, { x: -1, y: -1 }, null);

    Animated.timing(animationWidth, {
      toValue: 270,
      duration: 200,
      useNativeDriver: true,
    }).start();
  }, []);

  return (
    <View
      style={{ width: 72, height: "100%", zIndex: 2, backgroundColor: "red" }}
      onMouseLeave={() => {
        Animated.timing(animationWidth, {
          toValue: 72,
          duration: 200,
          useNativeDriver: true,
        }).start(onMouseLeave);
      }}
    >
      <Animated.View
        style={{
          position: "absolute",
          width: animationWidth,
          top: 0,
          left: 0,
          bottom: 0,
          backgroundColor: "#F7F2FA",
          overflow: "hidden",
          shadowColor: "#000",
          shadowOffset: { width: 0, height: 4 },
          shadowRadius: 5,
          shadowOpacity: 0.3,
          elevation: 2,
        }}
      >
        <View style={{ position: "absolute", width: 270, height: "100%" }}>
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              marginTop: 20,
              marginBottom: 38,
            }}
          >
            <TouchableOpacity
              style={{ marginHorizontal: "1rem" }}
              onPress={() => {
                if (navState.routeName == "Main") return;
                navigation.navigate("Main");
              }}
            >
              <Image
                source={require("../../assets/dashboard_icon.png")}
                style={{ width: 44, height: 44, marginTop: 8 }}
              />
            </TouchableOpacity>
            <Image
              style={{ width: Number(animationWidth) - 40, height: 30 }}
              source={require("../../assets/images/spinny_name.png")}
            />
          </View>
          <ScrollView showsVerticalScrollIndicator={false}>
            {screens.map((obj, index) => {
              if (obj.screen == "VOC" || obj.virtual) return null;

              return (
                <HeaderTab
                  key={index}
                  onPress={() => {
                    if (obj?.screen === "SparePartsScreen" || obj?.screen === "CatalogueRequests" || obj?.screen === "CatalogueManagementV2") {
                      return;
                    }
                    const params = {
                      label: obj.label,
                      headerTitle: obj.headerTitle,
                    };
                    if (obj.labelSt) params.labelSt = JSON.stringify(obj.labelSt);
                    if (obj.label == "Spares") params.tab = "purchase_request";
                    navigation.navigate(obj.screen, params);

                    if (obj?.screen?.toLowerCase() === "purchase") {
                      navigation.navigate(obj.screen, params);
                    }

                    console.log("SIDE MENU ----- ", params, obj);
                  }}
                  tabOnPress={(screen?, tab?) => {
                    console.log("OBJABC", obj, tab, screen);
                    if (obj?.screen?.toLowerCase() === "purchase") {
                      navigation.navigate(obj.screen);
                      return;
                    }
                    const params: any = { headerTitle: obj.headerTitle };
                    if (obj.labelSt) params.labelSt = JSON.stringify(obj.labelSt);
                    if (obj.label == "Spares" || obj?.label === "Catalogue") params.tab = tab;
                    if (screen === "" && hasSubHeader.hasOwnProperty(tab)) {
                      let localSubHeader = { ...hasSubHeader };
                      localSubHeader[tab] = !localSubHeader[tab];
                      updateHasSubHeader(localSubHeader);
                    }
                    navigation.navigate(screen, params);
                  }}
                  isActive={
                    navState.routeName === obj.screen ||
                    (sparesExtraScreens?.includes(navState.routeName) && obj.screen === "SparePartsScreen")
                  }
                  sparesTabs={sparesTabs}
                  text={obj.label}
                  bottomText={obj.bottomText}
                  img={obj.icon}
                  hasSubHeader={hasSubHeader}
                  icon={obj.navIcon}
                  navigation={navigation}
                />
              );
            })}
          </ScrollView>
        </View>
      </Animated.View>
    </View>
  );
};

export default Sidebar;

const headerStyles = StyleSheet.create({
  sideMenu: {
    overflow: "visible",
    maxWidth: 72,
    zIndex: 2,
  },
  tab: {
    flexDirection: "row",
    alignItems: "center",
    marginVertical: 10,
    paddingVertical: 20,
    paddingHorizontal: 15,
  },
  logo: { marginHorizontal: "1rem" },
  tabCon: {
    marginVertical: 5,
    paddingVertical: 10,
    paddingHorizontal: 20,
  },
  tabText: {
    marginStart: 40,
    fontFamily: "NotoSans",
    fontSize: 11,
    color: "#7D7D7D",
  },
});
